const ROLES = { volontario: "Volontario", ambulanza: "Autista ambulanza", mezzo: "Autista" };

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

function missing(svc, list) {
  const out = [];
  const amb = list.filter((s) => s.slot === "ambulanza").length;
  const vol = Math.max(0, (svc.required_volunteers || 0) - list.length);
  const drv = Math.max(0, (svc.required_ambulances || 0) - amb);
  if (vol) out.push(plural(vol, "volontario", "volontari"));
  if (drv) out.push(plural(drv, "autista ambulanza", "autisti ambulanza"));
  const driven = new Set(list.filter((s) => s.slot === "mezzo").map((s) => s.vehicle_id));
  (svc.required_vehicles || []).filter((v) => !driven.has(v.id)).forEach((v) => out.push(`autista ${v.name}`));
  return out;
}

const fmtDay = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

function MissingLine({ items, testid }) {
  if (!items.length) {
    return <p data-testid={testid} className="mt-1 text-xs font-semibold text-emerald-700">Al completo</p>;
  }
  return (
    <p data-testid={testid} className="mt-1 text-xs font-semibold text-amber-700">
      Mancano: {items.join(" · ")}
    </p>
  );
}

export function ServiceRoster({ svc }) {
  const dates = svc.dates?.length ? svc.dates : [svc.date_time];
  const vnames = Object.fromEntries((svc.required_vehicles || []).map((v) => [v.id, v.name]));
  const people = (svc.signups || []).filter((s) => ROLES[s.slot]);
  const multi = dates.length > 1;
  const groups = multi ? dates.map((d) => [d, people.filter((s) => (s.dates?.length ? s.dates : dates).includes(d))]) : [[dates[0], people]];
  return (
    <div className="mt-4 rounded-lg border border-border bg-muted/30 px-3 py-2.5" data-testid={`roster-${svc.id}`}>
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">Iscritti</p>
      {groups.map(([d, list], gi) => (
        <div key={d} className={gi ? "mt-2" : ""} data-testid={`roster-${svc.id}-${gi}`}>
          {multi && <p className="text-[11px] font-semibold text-[#D32F2F] mb-0.5">{fmtDay(d)}</p>}
          {list.length ? (
            <ul className="space-y-0.5">
              {list.map((s) => (
                <li key={s.user_id} className="text-sm flex justify-between gap-2">
                  <span className="truncate font-medium">{s.name}</span>
                  <span className="text-xs text-muted-foreground shrink-0">
                    {ROLES[s.slot]}{s.slot === "mezzo" && vnames[s.vehicle_id] ? ` ${vnames[s.vehicle_id]}` : ""}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-xs text-muted-foreground">Nessun iscritto</p>
          )}
          <MissingLine items={missing(svc, list)} testid={`roster-missing-${svc.id}-${gi}`} />
        </div>
      ))}
    </div>
  );
}
